<template>
    <el-dialog custom-class="dialogForm" class="measDialog" append-to-body :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" :title="title">
        <el-scrollbar class="dialogContentScroll">
            <el-form :model="form" ref="form" :rules="rules">
                <div class="formItemBox mb-15">
                    <el-form-item label="昵称" prop="nickname">
                        <el-input v-model="form.nickname" maxlength="20" show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="form.name" maxlength="20" show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="性别" prop="sex">
                        <el-radio v-model="form.sex" :label="1">男</el-radio>
                        <el-radio v-model="form.sex" :label="2">女</el-radio>
                    </el-form-item>
                    <el-form-item label="联系方式" prop="telno">
                        <el-input v-model="form.telno" maxlength="50" show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="证件类型" prop="idtype">
                        <el-select v-model="form.idtype" clearable>
                            <el-option v-for="item in idtypeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="证件号码" prop="idno">
                        <el-input v-model="form.idno" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="所在校区" prop="campuscode">
                        <SelectPage v-if="visible" @changePageGetList="changePageGetList" @getSelectValue="getSelectValue" :list="campusList" :label="'name'" :value="'code'" :paginationOption="campusPage" :isMultiple="false" :listLoading="campusLoading"></SelectPage>
                    </el-form-item>
                    <el-form-item label="标签" prop="label">
                        <!-- <el-input v-model="form.label" placeholder="请输入" clearable></el-input> -->
                        <div class="box">
                            <span class="box-tag ml-5" v-for="(item,index) in labelList" :key="index" v-show="labelList.length > 0">{{item}}
                                <i class="el-icon-close pointer" @click="deleteTags(index)"></i>
                            </span>
                            <el-input style="flex:1" class="ml-5 input" ref="input" v-model="label" @change="changeLabel" placeholder="请输入"></el-input>
                        </div>
                    </el-form-item>
                </div>
                <el-form-item label="说明" prop="summary">
                    <el-input v-model="form.summary" type="textarea" show-word-limit autosize maxlength="200" placeholder="请输入"></el-input>
                </el-form-item>
            </el-form>
        </el-scrollbar>
        <div slot="footer" style="text-align:right">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="isLoading" @click="saveStudent">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { getCampusList } from '@/api/measApi/campusManage.js'
import { getStudentDetails, saveStudent } from '@/api/measApi/studentManage.js'
import SelectPage from '@/components/measComponents/selectPage/selectPage.vue'
export default {
  data() {
    return {
      visible: false,
      title: '新增学员',
      form: {
        campuscode: '', // 所在校区code
        campusname: '', // 所在校区
        classcode: '', // 班级code
        idno: '', // 证件号码
        idtype: 1, // 证件类型 1 身份证 99 其他
        label: '', // 标签
        name: '', // 姓名
        nickname: '', // 昵称
        sex: 1, // 性别
        studentcode: '', // 学员code 编辑时需要
        summary: '', // 说明
        telno: '' // 联系方式
      },
      rules: {
        nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        campuscode: [
          { required: true, message: '请选择所在校区', trigger: 'change' }
        ]
      },
      idtypeList: [
        {
          value: 1,
          label: '身份证'
        },
        {
          value: 99,
          label: '其他'
        }
      ],
      orgForm: {},
      isLoading: false,
      campusList: [],
      campusPage: {
        pagesize: 5,
        page: 1,
        total: 0
      },
      campusLoading: false,
      label: '',
      labelList: []
    }
  },
  components: {
    SelectPage
  },
  methods: {
    handleOpen(code, classCode) {
      this.visible = true
      this.orgForm = JSON.parse(JSON.stringify(this.form))
      this.form.classcode = classCode || ''
      this.getCampusList()
      if (code) {
        this.title = '编辑学员'
        getStudentDetails({ code: code }).then(res => {
          if (res.code === '000') {
            this.form = res.data
            if (this.form.label) {
              this.labelList = this.form.label.split(',')
            }
          }
        })
      } else {
        this.title = '新增学员'
      }
    },
    // 获取校区列表
    getCampusList() {
      const params = {
        condition: {
          name: '',
          classcode: this.form.classcode
        },
        page: this.campusPage.page,
        pagesize: this.campusPage.pagesize
      }
      this.campusLoading = true
      getCampusList(params).then(res => {
        if (res.code === '000') {
          this.campusList = res.data
          this.campusPage.total = res.pageinfo.rowcount
          this.campusLoading = false
        }
      })
    },
    changePageGetList(page) {
      this.campusPage.page = page
      this.getCampusList()
    },
    getSelectValue(args) {
      this.form.campuscode = args[0].code
      this.form.campusname = args[0].name
    },
    // enter创建tag
    changeLabel(value) {
      if (value) {
        this.labelList.push(value)
        this.label = ''
      }
    },
    // 删除tag
    deleteTags(index) {
      this.labelList.splice(index, 1)
    },
    // 保存
    saveStudent() {
      this.$refs.form.validate(validate => {
        if (validate) {
          if (this.labelList && this.labelList.length > 0) {
            this.form.label = this.labelList.join(',')
          }
          if (!this.form.telno && !this.form.idno) {
            this.$message.warning('联系方式和证件号码不能都为空')
            return
          }
          if (!this.form.telno && !this.form.idtype) {
            this.$message.warning('请选择证件类型')
            return
          }
          this.isLoading = true
          saveStudent(this.form).then(res => {
            this.isLoading = false
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.$emit('saveSuccess')
              this.handleClose()
            } else {
              this.$message.success(error.msg)
            }
          })
        }
      })
    },
    handleClose() {
      if (this.isLoading) {
        this.$message.warning('提交数据中，请稍等')
        return
      }
      this.visible = false
      this.form = this.orgForm
      this.label = ''
      this.labelList = []
      this.$refs.form.clearValidate()
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: flex;
  flex-wrap: wrap;
  &-tag {
    background: #f6f7fb;
    border-radius: 4px 4px 4px 4px;
    height: 24px;
    padding: 0px 10px;
    display: flex;
    align-items: center;
    color: #999999;
    font-size: 12px;
    margin-top: 6px;
    i {
      margin-left: 8px;
    }
  }
  .input {
    ::v-deep .el-input__inner {
      border: none;
      height: 32px !important;
    }
  }
}
</style>

